
export const firebaseConfig = {
  /*apiKey: "AIzaSyA9tJ1p8iDcYy6tLoOisnr4zXFbS8aHEag",
  authDomain: "restaurant-1440e.firebaseapp.com",
  databaseURL: "https://restaurant-1440e.firebaseio.com",
  storageBucket: "restaurant-1440e.appspot.com",
  messagingSenderId: "314198464457"*/
  apiKey: "AIzaSyBIFOG-dmT9pUhCwzXcnzcaOP0YkcqJdCk",
  authDomain: "shunfa-6cfdd.firebaseapp.com",
  databaseURL: "https://shunfa-6cfdd.firebaseio.com",
  projectId: "shunfa-6cfdd",
  storageBucket: "shunfa-6cfdd.appspot.com",
  messagingSenderId: "355219589202"
};

export const cloudinarUpload = {
  cloudName: 'ocomedia',
  uploadPreset: 'ui0cyga0'
};





// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/firebase.config.ts